/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    d="m22.1522 0-1.2268 1.6477c-.7251.9739-1.0717 1.9049-1.0717 2.8094 0 .7771.2558 1.5737.7876 2.4002L22.5 6.8571V24H5.9032c-2.348 0-4.2667-1.8603-4.3962-4.2042l-.007-.2529V4.4571l.007-.2529C1.6319 1.944 3.4205.1335 5.6534.0071L5.9032 0h16.249ZM3.5315 8.2131l.0008 11.3298c0 1.2592.958 2.2919 2.1765 2.392l.1944.008h14.5645V8.9143H5.9032a4.3441 4.3441 0 0 1-2.3717-.7012Zm7.2446 8.5948c.5612 0 1.0161.4605 1.0161 1.0286 0 .5207-.3823.951-.8782 1.0191l-.1379.0094H7.8826c-.5613 0-1.0162-.4605-1.0162-1.0285 0-.5208.3823-.9511.8783-1.0192l.1379-.0094h2.8935Zm5.4193-4.7731c.5612 0 1.0162.4605 1.0162 1.0286 0 .5207-.3823.9511-.8783 1.0192l-.1379.0094H7.8826c-.5613 0-1.0162-.4605-1.0162-1.0286 0-.5207.3823-.9511.8783-1.0192l.1379-.0094h8.3128Zm2.1398-9.9777H5.9032c-1.1748 0-2.1501.865-2.3382 2.0002l-.0249.203-.0078.1968c0 1.2593.958 2.292 2.1765 2.392l.1944.008h12.4334l-.1409-.3501c-.1655-.4502-.2767-.9043-.3324-1.3616l-.0314-.3435-.0105-.3448c0-.8056.1716-1.6023.5138-2.4Z"
  />,
  'MenuReferences'
);
